import React, { useState } from "react";
import classes from "./SurveysPage.module.css";
import { CreateEditSurveyModal } from "./CreateEditSurveyModal/CreateEditSurveyModal";
import SurveysList from "./SurveysList";
import { ProjectsHeader } from "../Projects/ProjectsHeader";
import SelectSurveyTemplateModal from "./SelectSurveyTemplateModal/SelectSurveyTemplateModal";
import { surveyTemplates } from "../../utils/surveyTemplates/surveyTemplates";
import { SurveysActionsComponent } from "./SurveysActionsComponent";

function SurveysPage() {
    const [isCreateSurveyModalOpen, setIsCreateSurveyModalOpen] =
        useState(false);
    const [isSelectTemplateModalOpen, setIsSelectTemplateModalOpen] =
        useState(false);
    const [surveyTemplate, setSurveyTemplate] = useState(null);

    const handleCreateSurvey = () => {
        setIsSelectTemplateModalOpen(true);
    };

    const closeCreateSurveyModalHandler = () => {
        setIsCreateSurveyModalOpen(false);
    };

    const goNextTemplateModalHandler = () => {
        setIsSelectTemplateModalOpen(false);
        setIsCreateSurveyModalOpen(true);
    };

    const selectSurveyTemplateHandler = (template) => {
        setSurveyTemplate(
            surveyTemplates.find((item) => item.name === template)
        );
    };

    return (
        <>
            <SelectSurveyTemplateModal
                onCancel={() => setIsSelectTemplateModalOpen(false)}
                onNext={goNextTemplateModalHandler}
                isOpen={isSelectTemplateModalOpen}
                onSelectTemplate={selectSurveyTemplateHandler}
            />
            <ProjectsHeader />
            <div className="container">
                <div className="projects-section">
                    <div className={classes["surveys-heading-bar"]}>
                        <button onClick={() => handleCreateSurvey()}>
                            New Survey
                        </button>
                    </div>

                    <SurveysList />
                    {isCreateSurveyModalOpen && (
                        <CreateEditSurveyModal
                            surveyTemplate={surveyTemplate}
                            isOpen={isCreateSurveyModalOpen}
                            onClose={closeCreateSurveyModalHandler}
                        />
                    )}
                </div>
            </div>
        </>
    );
}

export default SurveysPage;
